import React from 'react'
import RadioBox from './RadioBox'

function RadioGroup(props) {
  const {
    container = '', radioBoxContainer = '',
    options = [],
    onChange = (f) => f,
    value = '',
    label = '',
    name = '',
  } = props

  return (
    <div className={container}>
     {label && <h6 className={'fw-bold'}>{label}</h6>}
      {/* <h6 className={'font-weight-bold' + themeClass}>{label}</h6> */}

      <div className="d-flex flex-row">
        {/* {JSON.stringify({name, value})} */}
        {options.map((_item, _i) => (
          <RadioBox
            container={`mx-4 ${radioBoxContainer}`}
            label={_item.label}
            name={name}
            checked={_item.name === value}
            onChange={() => onChange(name, _item.name)}
          />
        ))}
      </div>
    </div>
  )
}

export default RadioGroup
